import { Model } from "@/models/base/model";
import { NoteType } from "@/views/pages/MyRecord/HospitalVisit/ClinicNote/types";

type ClinicDataParams = {
  hospitalVisitId: number | null; // 病院受診ID
};

type CondtionDataParams = {
  startDate: string; // 抽出開始日
  endDate: string; // 抽出終了日
};

type DailyNoteParam = {
  initial: boolean; // 初回ロード
  checkedCount: number; // チェック済み件数
  type: NoteType; // 診察ノートタイプ
  month: string; // 対象月
};

export default class ClinicNote extends Model {
  private baseUrl = "/cms/api/my-record/hospital-visit/clinic-note"; // ベースURL
  // -----------------------------------------------------------------------

  // クエリパラメータリクエスト
  async fetchQuery(url: string, data: any): Promise<any> {
    this.url = `${this.baseUrl}/${url}`;
    if (data) {
      const searchParams = new URLSearchParams();
      for (const [key, value] of Object.entries(data)) {
        if (value !== undefined && value !== null) {
          searchParams.append(key, value.toString());
        }
      }
      this.url = `${this.url}?${searchParams.toString()}`;
    }
    return await super.fetch();
  }
  // -----------------------------------------------------------------------

  // コンストラクタ
  constructor(params: any = {}) {
    super(params);
    this.url = this.baseUrl;
  }

  // 診察記録の取得
  async getClinicData(data: ClinicDataParams | null): Promise<any> {
    return await this.fetchQuery("", data);
  }

  // 診察ノートの保存
  async saveNote(): Promise<any> {
    this.url = `${this.baseUrl}/save-note`;
    return await super.save({}, "POST");
  }

  // 体調データの取得
  async getConditionData(data: CondtionDataParams | null): Promise<any> {
    return await this.fetchQuery("get-condition", data);
  }

  // 症状・こころノートの取得
  async getDailyNote(data: DailyNoteParam): Promise<any> {
    return await this.fetchQuery("get-dailynote", data);
  }

  // 表示期間を設定
  async setSpan(params: {
    startDate: string;
    endDate: string;
    hospitalVisitId: number;
  }): Promise<any> {
    this.url = `${this.baseUrl}/set-span`;
    return await super.save(params, "POST");
  }
}
